import {httpModel} from '../../http/httpModel'
import {parsePoint, getDistance} from '../../utils/getLocalPosition'
import {transToBD09} from '../../utils/globalFunction'
import {getOrgTreeData} from '../../model/tree'
import BMap from 'BMap'
const homeModule = {
  state: {
    orgId: '',
    boxInfo: '',
    orgTreeData: [],
  },
  mutations: {
    setOrgId: (state, id) => {
      state.orgId = id
    },
    setBoxInfo: (state, info) => {
      // console.log(info)
      state.boxInfo = info
    },
    setOrgTreeData: (state, tree) => {
      state.orgTreeData = tree
    }
  },
  getters: {
    broadcastTree: state => {
      const formatTree = (tree = []) => {
        // console.log(tree)
        let broadcastData = tree.map((item) => {
          let title = item.entity || item.name
          let key = item.entity ? item.id.toString() : ''
          // let disableCheckbox = item.deviceID ? false : true
          if (item.hasOwnProperty('children') || item.hasOwnProperty('entitys')) {
            let children = item.children ? formatTree(item.children).concat(formatTree(item.entitys)) : formatTree(item.entitys)
            return {
              title,
              key,
              // disableCheckbox,
              children
            }
          } else {
            return {
              title,
              key,
              // disableCheckbox,
            }
          }
        })
        return broadcastData
      }
      return formatTree(state.orgTreeData)
    }
  },
  actions: {
    // 改变了首页的当前机构ID
    changedHomeOrgId: ({state, commit, rootState}, payload) => {
      // console.log(payload)
      commit('setOrgId', payload)
    },
    // 显示的infobox内容改变
    changedInfoBox: ({state, commit, rootState}, info) => {
      return new Promise((resolve) => {
        httpModel.getEntityCurrentHealth(info.id).then((res) => {
          // console.log(res)
          info.step = res.step
          info.heartbeat = res.heart
          let bd09Point = transToBD09(info.coord_type, info.lng, info.lat)
          // getLocalPosition(new BMap.Point(bd09Point.lng, bd09Point.lat)).then((address) => {
          //   info.address = address
          //   // console.log(info)
          //   commit('setBoxInfo', info)
          //   resolve()
          // })
          // parsePoint(new BMap.Point(bd09Point.lng, bd09Point.lat)).then((res) => {
          //   info.address = res.address
          //   if (res.surroundingPois.length > 0) {
          //     info.surroundingPois = res.surroundingPois.map((item) => {
          //       // 计算周边点与定位点之间的距离
          //       // let distance = Math.round(map.getDistance(pt, item.point))
          //       let distance = getDistance(bd09Point.lng, bd09Point.lat, item.point.lng, item.point.lat)
          //       // console.log(distance)
          //       return Object.assign({distance}, item)
          //     })
          //   } else if (res.business) {
          //     info.surroundingPois = [
          //       {
          //         title: res.business,
          //         distance: null
          //       }
          //     ]
          //   } else {
          //     info.surroundingPois = null
          //   }
          //   commit('setBoxInfo', info)
          //   resolve()
          // })
        })
      })
    },
    // 初始化orgTree
    initOrgTree: ({state, commit}) => {
      // 请求数据
      getOrgTreeData().then((tree) => {
        console.log(tree)
        // 提交
        commit('setOrgTreeData', tree)
      })
    }
  }
}

export default homeModule